import axios from "axios";
import {addAuthKey} from '@/helpers/addAuthKeyToUrl';

const api_url = "/index.php";

export default {
    namespaced: true,

    store: {
        roles: [],
        posts: [],
        totalItemsCount: 0
    },

    state: {
        totalItemsCount: 0,
    },

    mutations: {
        setRoles(state, roles) {
            state.roles = roles.map(i => ({
                value: i.name,
                label: i.description
            }));
        },
        setPosts(state, posts) {
            state.posts = posts.map(i => ({ value: i.id, label: i.name }));
        },
        setTotalItemsCount(state, totalItemsCount) {
            state.totalItemsCount = totalItemsCount;
        }
    },

    actions: {
        // список таблиц с настройками
        async getList({commit, rootState}, params) {
            const token = rootState.authToken;
            const searchParams = {
                auth_key: rootState.authToken,
                r: "api/calculation-sheet/automatic-list",
                page: params.page
            };

            if (params.globalFilters) {
                if (params.globalFilters.filial && params.globalFilters.filial.length) {
                    searchParams.filial_value = params.globalFilters.filial.map(filial => (filial.value)).join(',');
                    searchParams.filial_search_type = params.globalFilters.filialReverse ? 2 : 1;
                }
            }

            const search = Object.entries(searchParams)
                .map(([key, value]) => `${key}=${value}`)
                .join("&");

            const { data, headers } = await axios.get(addAuthKey(`${api_url}/?${search}`, token));

            commit("setTotalItemsCount", +headers["x-pagination-total-count"]);

            return data;
        },

        // удалить настройки для таблицы
        async removeTableSettings(ctx, params) {
            const token = ctx.rootState.authToken;
            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/calculation-sheet/delete-automatic-sheet&id=${params.id}`, token),
                {
                    method: "POST"
                }
            );

            const json = await res.json();

            return json;
        },

        // получить список всех таблиц
        async getTables(ctx) {
            const token = ctx.rootState.authToken;
            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/columns-settings/table-sections`, token)
            );

            const json = await res.json();

            return json;
        },

        // получить сохраненные настройки таблицы
        async getTableSettings(ctx, params) {
            const token = ctx.rootState.authToken;
            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/columns-settings/view&id=${params.id}`, token)
            );

            const json = await res.json();

            return json;
        },

        // получить набор столбцов для таблицы
        async getTableColumns(ctx, params) {
            const token = ctx.rootState.authToken;
            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/columns-dictionary/list&section=${params.table}`, token)
            );

            const json = await res.json();

            return json;
        },

        // список ролей
        async getRoles(ctx) {
            const token = ctx.rootState.authToken;
            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/roles/list`, token)
            );

            const json = await res.json();

            ctx.commit("setRoles", json);

            return json;
        },

        // список должностей
        async getPosts(ctx) {
            const token = ctx.rootState.authToken;
            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/worker-profile/posts-list`, token)
            );

            const json = await res.json();

            ctx.commit("setPosts", json.response);
        },

        // создать настройки для новой таблицы
        async createTableSettings(ctx, params) {
            const token = ctx.rootState.authToken;

            const formData = new FormData();

            Object.entries(params).forEach(([key, value]) => {
                formData.append(key, value);
            })

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/calculation-sheet/create-automatic-sheet`, token),
                {
                    method: "POST",
                    body: formData
                }
            );

            const json = await res.json();

            return json;
        },

        // обновить настройки для новой таблицы
        async updateTableSettings(ctx, {params, id}) {
            console.log('UPDATE')
            const token = ctx.rootState.authToken;

            const formData = new FormData();

            Object.entries(params).forEach(([key, value]) => {
                formData.append(key, value);
            })

            console.log({params, id})

            const res = await fetch(
                addAuthKey(`${api_url}/?r=api/calculation-sheet/edit-automatic-sheet&id=${id}`, token),
                {
                    method: "POST",
                    body: formData
                }
            );

            const json = await res.json();

            return json;
        }
    }
};
